module.exports = __webpack_public_path__ + "img/bingo_ball-51.2ee292c4.png";